var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("li", { staticClass: "list-group-item" }, [
    _c(
      "div",
      {
        staticClass:
          "form-group d-flex justify-content-between align-items-center m-0"
      },
      [
        _c("div", { staticClass: "m-0 min-width" }, [
          _c("p", { staticClass: "m-0" }, [
            _vm.icon !== ""
              ? _c("i", { staticClass: "fad", class: _vm.icon })
              : _vm._e(),
            _vm._v(
              _vm._s(_vm.icon ? " " : "") +
                _vm._s(_vm.label !== "" ? _vm.label : "")
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "w-100 ml-3" }, [
          _c("p", { staticClass: "m-0 text-right" }, [_vm._v(_vm._s(_vm.text))])
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }